import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09d1c1c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cmpLayer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hideMobile" }, "Manage Settings : Our Partners", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "hideDesktop",
  style: {"font-size":"16px"}
}, "Our Partners", -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"listItemHeader\" data-v-09d1c1c0><div class=\"descriptionLabel\" data-v-09d1c1c0>Partner Name</div><div style=\"flex-grow:1;\" data-v-09d1c1c0></div><div class=\"descriptionLabel\" style=\"margin-left:8px;\" data-v-09d1c1c0>Consent</div><div class=\"vendorControlLabel\" style=\"width:30px;margin-left:8px;\" data-v-09d1c1c0> </div></div>", 1)
const _hoisted_5 = { class: "scrollingContainer" }
const _hoisted_6 = ["v-if"]
const _hoisted_7 = { class: "cmpButtonContainer" }
const _hoisted_8 = {
  key: 0,
  class: "cmpButtonLink manageLinkDisabled"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"-14px"} }, "Accept All and Exit", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "cmpSVGButtonArrow",
  "clip-rule": "evenodd",
  "fill-rule": "evenodd",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "2",
  viewBox: "0 0 500 500",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "__cmpIcon",
    d: "M479.3 250L246.5 482.7l-67.1-67L345 250 179.4 84.4l67.1-67.1L479.3 250z"
  })
], -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VendorListDivider = _resolveComponent("VendorListDivider")!
  const _component_NonTCFVendorItem = _resolveComponent("NonTCFVendorItem")!
  const _component_VendorListItem = _resolveComponent("VendorListItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", null, [
      _createTextVNode("The partners with whom we work is shown below. You may expand each one to review how your data is processed. Use the toggle buttons to consent to purposes requiring consent or object to legitimate interests for each partner. You may also review the list of "),
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.purposesClick && _ctx.purposesClick(...args)), ["prevent"]))
      }, "purposes and features"),
      _createTextVNode(" for more information.")
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        "v-if": _ctx.nonTCFVendors.length
      }, [
        _createVNode(_component_VendorListDivider, { label: "Partners Not Participating in the IAB TCF" }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nonTCFVendors, (vendor) => {
          return (_openBlock(), _createBlock(_component_NonTCFVendorItem, {
            vendor: vendor,
            key: vendor.id,
            onHandleModelChangeEvent: _ctx.handleModelChangeEvent
          }, null, 8, ["vendor", "onHandleModelChangeEvent"]))
        }), 128)),
        _createVNode(_component_VendorListDivider, { label: "Partners Participating in the IAB TCF" })
      ], 8, _hoisted_6),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedVendorIds, (vendorID) => {
        return (_openBlock(), _createBlock(_component_VendorListItem, {
          vendor: _ctx.vendors[vendorID],
          key: vendorID,
          onHandleModelChangeEvent: _ctx.handleModelChangeEvent
        }, null, 8, ["vendor", "onHandleModelChangeEvent"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (!_ctx.dirty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Save and Exit"))
        : _createCommentVNode("", true),
      (_ctx.dirty)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "cmpButtonLink manageLink",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveAndExitClick && _ctx.saveAndExitClick(...args)))
          }, "Save and Exit"))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        class: "cmpButtonLink rejectLink",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rejectAllClick && _ctx.rejectAllClick(...args)))
      }, "Reject All and Exit"),
      _createElementVNode("a", {
        class: "cmpButtonLink acceptLink",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.acceptAllClick && _ctx.acceptAllClick(...args))),
        style: {"position":"relative"}
      }, _hoisted_11)
    ])
  ]))
}